module.exports = __webpack_public_path__ + "static/media/pay-by-payanyone.fe222096.png";